import React from 'react';
import { FaCheck, FaTimes, FaExchangeAlt } from 'react-icons/fa';
import '../styles/resumeUpdateModal.css';

const ResumeUpdateModal = ({
  sectionName,
  currentContent,
  proposedContent,
  onApprove,
  onReject,
  isMobile = false,
}) => {
  // Format long texts with newlines for clean display
  const formatText = (text) => {
    if (!text) return <p className="empty-content-placeholder">No content currently filled</p>;
    return text.split('\n').map((line, idx) => (
      <React.Fragment key={idx}>
        {line}
        <br />
      </React.Fragment>
    ));
  };

  return (
    <div className={`resume-update-modal-overlay ${isMobile ? 'mobile-view' : ''}`}>
      <div className="resume-update-modal-card">
        <div className="modal-header">
          <div className="modal-title-wrapper">
            <div className="modal-icon-badge">
              <FaExchangeAlt />
            </div>
            <h2>Review Proposed Update: <span className="highlight-section">{sectionName}</span></h2>
          </div>
          <button className="modal-close-btn" onClick={onReject} aria-label="Close modal">
            <FaTimes />
          </button>
        </div>

        <div className="modal-description">
          The AI Career Coach has proposed enhancements to your <strong>{sectionName}</strong>. Review the changes below:
        </div>

        <div className="comparison-container">
          <div className="comparison-pane current-pane">
            <div className="pane-header">
              <span className="badge badge-current">Current Version</span>
            </div>
            <div className="pane-content">
              {formatText(currentContent)}
            </div>
          </div>

          <div className="comparison-divider-arrow">
            <FaExchangeAlt />
          </div>

          <div className="comparison-pane proposed-pane">
            <div className="pane-header">
              <span className="badge badge-proposed">Proposed Enhancements</span>
            </div>
            <div className="pane-content">
              {formatText(proposedContent)}
            </div>
          </div>
        </div>

        <div className="modal-actions-footer">
          <button className="btn-action-reject" onClick={onReject}>
            <FaTimes style={{ marginRight: '8px' }} /> Keep Current
          </button>
          <button className="btn-action-approve" onClick={onApprove}>
            <FaCheck style={{ marginRight: '8px' }} /> Approve & Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeUpdateModal;
